import {SET_NAVIGATION_TASKS} from "./action-types"

export const setNavigationTasks = (data) => {
    return {
      type: SET_NAVIGATION_TASKS,
      payload: data
    }
  }